import { render, staticRenderFns } from "./program-attendees.vue?vue&type=template&id=e2613e80&scoped=true&"
import script from "./program-attendees.vue?vue&type=script&lang=js&"
export * from "./program-attendees.vue?vue&type=script&lang=js&"
import style0 from "./program-attendees.vue?vue&type=style&index=0&id=e2613e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2613e80",
  null
  
)

export default component.exports